// 전체 판매 개수
export const isShowTotalSelling = false
